export default __webpack_public_path__ + "files/media/nysf-google-md.c1a269f5.jpg";